import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { sessionsApi } from 'api';
import { usePanel } from 'contexts/panelContext';
import { Loader } from 'components/_new/Loader';
import { SessionTypeEnum } from 'types/Session';

export const SessionLastRedirect = () => {
	const { pairId, subpage } = useParams();
	const { hash } = useLocation();

	const { userPairsLoading, currentProgramMembership, panelLinkPrefix } = usePanel();
	const userPanelPairSessionLinkPrefix = `${panelLinkPrefix}/pair/${pairId}/session`;

	const { data: sessionsData, isLoading: sessionsLoading } = useQuery(
		['sessions', { pairId: Number(pairId) }],
		() => sessionsApi.getSessions(Number(pairId), currentProgramMembership.id),
		{ enabled: Boolean(currentProgramMembership) }
	);
	const lastSession = sessionsData?.find((session) => session.sessionType === SessionTypeEnum.LAST);

	if (userPairsLoading || sessionsLoading) {
		return <Loader />;
	}

	if (lastSession) {
		return (
			<Navigate
				to={{
					pathname: `/${userPanelPairSessionLinkPrefix}/${lastSession.id}${
						subpage && subpage.length > 0 ? `/${subpage}` : ''
					}`,
					hash,
				}}
			/>
		);
	}

	return <Navigate to={{ pathname: `/${userPanelPairSessionLinkPrefix}` }} />;
};
